import { Button, CircularProgress, DialogActions, DialogTitle } from '@mui/material';
import { useState } from 'react';
import { DialogType } from '../../@types';
import { MESSAGES } from '../../constants/messages';

type ConfirmDialog = DialogType & {
  handleConfirm: () => void | Promise<void>;
  title?: string;
  actionButtonLabel?: string;
  actionButtonClose?: string;
};

const ConfirmationModal = ({
  title,
  actionButtonLabel,
  handleConfirm,
  closeModal,
  actionButtonClose,
}: ConfirmDialog) => {
  const [pending, setPending] = useState(false);

  const onConfirm = async () => {
    if (pending) return;

    try {
      setPending(true);
      await Promise.resolve(handleConfirm());
      closeModal?.();
    } finally {
      setPending(false);
    }
  };

  return (
    <>
      <DialogTitle variant='h4' align='center' gutterBottom>
        {title ?? MESSAGES.CONFIRM_DELETE}
      </DialogTitle>
      <DialogActions>
        {actionButtonClose && (
          <Button variant='outlined' onClick={closeModal} disabled={pending}>
            {actionButtonClose ?? 'Cancel'}
          </Button>
        )}
        <Button variant='contained' onClick={onConfirm} disabled={pending}>
          {pending ? <CircularProgress size={20} color='inherit' /> : actionButtonLabel ?? 'Delete'}
        </Button>
      </DialogActions>
    </>
  );
};

export default ConfirmationModal;
